<template>
  <div style="height:100%">
    <div class="row-center comparison-head" v-if="$route.params.name == 'Comparison'">
      <div @click="checkurl('none')"  :class="uid=='none'?'active name':'name'">回路对比</div>
      <div @click="checkurl('two')" :class="uid=='two'?'active name':'name'">时段对比</div>
    </div>
    <template class v-if="routeName === 'Overview'">
      <Overview></Overview>
    </template>
    <template class v-else-if="routeName === 'Bill'">
      <Bill></Bill>
    </template>
    <template class v-else-if="routeName === 'Ranking'">
      <Ranking></Ranking>
    </template>
    <template v-else>
      <div id="power-data" class="row-center" v-if="reFresh">
        <template>
          <div
            class="left column-center"
            v-if="routeName === 'Comparison' || routeName === 'Pinnacle'"
          >
            <area-details
              v-if="allArea[details]"
              width="180"
              :details="allArea[details]"
              @click.native.stop="listShow = !listShow"
            ></area-details>
            <div class="list">
              <div class="search">
                <input
                  type="text"
                  v-model="filterText"
                  placeholder="请输入关键字"
                />
                <img src="../../assets/img/search.png" alt="" />
              </div>
              <div class="tree" id="index-tree" :style="$route.params.name == 'Comparison' ? 'height:60vh' : ''">
                <el-scrollbar style="height:100%">
                  <el-tree
                    :default-checked-keys="defaultchecked"
                    :expand-on-click-node="false"
                    check-strictly
                    :check-on-click-node="checkno"
                    default-expand-all
                    @check="currentChange"
                    :show-checkbox="showCheckBox"
                    node-key="loopId"
                    @node-click="nodeClick"
                    ref="tree"
                    :data="treeData"
                    :filter-node-method="filterNode"
                  >
                    <span
                      slot-scope="{ node, data }"
                      class="power-data-item"
                      :title="
                        data.label.replace(/[^\x00-\xff]/g, 'AA').length > 22
                          ? data.label
                          : ''
                      ">
                      <span
                        :class="[
                          'power-data-item-label',
                          { checked: data.loopId === currentLoop.loopId },
                        ]"
                      >
                        <span slot="reference"> {{ node.label }}</span>
                      </span>
                    </span>
                  </el-tree>
                </el-scrollbar>
              </div>
            </div>
            <div class="clearsel" v-if="uid=='none'&&routeName=='Comparison'" @click="resetChecked()">清空选择</div>
          </div>
          <div class="data">
            <component
              :selectedLoops="checkedLoops"
              :currentLoop="currentLoop"
              :is="componentName"
              :uid="uid"
            />
            <div
              @click.stop=""
              class="area-list column-center"
              style="justify-content: flex-start"
              v-show="listShow"
            >
              <div class="search row-center">
                <input
                  type="text"
                  placeholder="请输入关键词"
                  v-model="areaFilterText"
                />
                <img src="../../assets/img/search.png" alt="" />
              </div>
              <div class="areas">
                <template v-if="showAreaNumber === 0">
                  <span style="color: #8c939d; font-size: 18rem">暂无数据</span>
                </template>
                <template v-else v-for="(item, index) in allArea">
                  <div
                    class="row row-center"
                    style="justify-content: space-between; cursor: pointer"
                    :key="index"
                    v-if="areaFilter(item)"
                    @click.stop="(details = index), (listShow = false)"
                  >
                    <img :src="item.areaImg" alt="" />
                    <p>{{ item.areaName }}</p>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
import AreaDetails from "../../components/home/AreaDetails";
import PowerData from "./PowerData";
import PinnacleData from "./PinnacleData";
import ComparisonData from "./ComparisonData";
import Overview from "./sheet/Overview.vue";
import Bill from "./sheet/Bill.vue";
import Ranking from "./sheet/Ranking.vue";
import { GET_AREAS, GET_AREA_LOOPS } from "../../api/power";

import { subscribe, unsubscribe, subscribeByNodes } from "../../mqtt/index";
import {
  subscribe as alarmSubscribe,
  unsubscribe as alarmUnsubscribe,
} from "../../mqtt/alarm";
export default {
  name: "EnergyEfficiency",
  components: {
    AreaDetails,
    PowerData,
    PinnacleData,
    ComparisonData,
    Overview,
    Bill,
    Ranking,
  },
  data() {
    return {
      selectedNodes: [],
      showAreaNumber: 0,
      reFresh: true,
      checkedLoops: [],
      currentLoop: null,
      filterText: "",
      listShow: false,
      details: -1,
      areaFilterText: "",
      allArea: [],
      loops: [],
      checkno:true,
      defaultchecked:[],
      uid:"none"
    };
  },

  computed: {
    tag() {
      return this.$route.params.tag;
    },
    routeName() {
      return this.$route.params.name;
    },
    showCheckBox() {
      return !(this.routeName === "Pinnacle"||this.uid==='two');
    },
    componentName() {
      switch (this.$route.params.name) {
        case "Overview":
        case "Bill":
        case "Pinnacle":
          return "PinnacleData";
        case "Comparison":
          this.uid = 'none'
          return "ComparisonData";
      }
    },
    master() {
      if (!this.allArea[this.details]) {
        return;
      }
      let areaId = this.allArea[this.details].areaId;
      let master = this.loops.filter((e) => e.masterAreaId === areaId);
      console.log( master[0])
      return master[0];
    },
    powerDataTree() {
       if (!this.allArea[this.details] || this.loops.length === 0) {
            return;
        }
        let areaId = this.allArea[this.details].areaId;

        this.loops = this.loops.filter(
            (l) => l.loopName.indexOf("电容补偿") === -1
        );
        let master = this.loops.filter((loop) => loop.loopType === "IN");
        if (!master) {
            // console.log(this.loops);
            return this.loops.map((item, index) => {
                item.label = item.loopName;
                item.id = index;
            });
        }
        // 存在进线
        let loopMap = {};
        // 将master的loopId作为key, 放入loopMap, value初始为[];
        master.forEach((item) => (loopMap[item.loopId] = []));
        // 遍历loops, 将所有OUT回路以pid(父级回路id)放入loopMap中的对应数组中
        // console.log(this.loops)
        this.loops.forEach((loop, index) => {
            loop.label = loop.loopName;
            loop.id = index;
            if (loop.loopType === "OUT") {
                if (this.routeName == "Extremum" || this.routeName == "Running") {
                    //报表管理不加电容补偿

                    if (loop.loopName.indexOf("电容补偿") == -1) {
                        if (loopMap[loop.pid]) {
                            loopMap[loop.pid].push(loop);
                        }
                    }
                } else {
                    if (loopMap[loop.pid]) {
                        loopMap[loop.pid].push(loop)
                    }
                }

                // console.log(1)
            }
        });
        master.forEach((item) => {
            item.children = loopMap[item.loopId];
        });
        return master;
    },
    treeData() {
      switch (this.$route.params.name) {
        case "Pinnacle":
        case "Comparison":
        case "Pinnacle":
        case "Running":
          this.defaultchecked = [1167]
          this.currentLoop = this.master;
          this.checkedLoops = [this.master]
          return this.powerDataTree;
      }
    },
  },
  mounted() {
    GET_AREAS().then((res) => {
      this.allArea = res.data.data.areas;
      this.details = 0;
      this.showAreaNumber = res.data.data.areas.length;
    });
    document.onclick = () => {
      this.listShow = false;
    };
  },
  methods: {
    checkurl(url){
      this.uid = url
    },
    resetChecked(){
      this.checkedLoops = []
      this.$refs.tree.setCheckedKeys([]);
    },
    mouseenter(data) {
      this.$set(data, "show", true);
    },
    mouseleave(data) {
      this.$set(data, "show", false);
    },
    unique(arr) {
      return Array.from(new Set(arr));

    },
    currentChange(data, node, n) {
        let arr = node.checkedKeys
        if(this.uid=='none'&&this.routeName === "Comparison"){
          if(node.checkedNodes.length>5){
            this.$message('最多只能选择5个');
            arr = arr.filter((num,index)=>{return num !== data.loopId})
            this.$refs.tree.setCheckedKeys(arr)
            return 
          }else{
            this.selectedNodes = node.checkedNodes;
            this.checkedLoops = this.selectedNodes.filter((l) => {
              return l ? l.loopName.indexOf(this.filterText) !== -1 : false;
            });
          }
        }else{
          this.selectedNodes = node.checkedNodes;
            this.checkedLoops = this.selectedNodes.filter((l) => {
              return l ? l.loopName.indexOf(this.filterText) !== -1 : false;
            });
        }

    },
    //点击传参
    //侧边栏子回路点击之后传参
    nodeClick(data) {
      this.$store.commit("ArcprotectStatus", data);
      this.currentLoop = data;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    areaFilter(item) {
      if (!this.areaFilterText) {
        return true;
      }
      return item.areaName.indexOf(this.areaFilterText) !== -1;
    },
    updateMqtt(n, o) {
      // debugger
      if (o && o.subLoopUrl) {
        unsubscribe([o.subLoopUrl]);
        alarmUnsubscribe([o]);
      }
      if (n && n.subLoopUrl) {
        subscribe([n.subLoopUrl]);
        alarmSubscribe([n]);
      }
    },
  },
  watch: {
    uid(n,o){
      // if(n){
      //   this.checkedLoops = []
      //   this.$refs.tree.setCheckedKeys([]);
      // }
      if(n=='two'){
        this.checkno = false
      }else{
        this.checkno = true
      }
    },
    areaFilterText(n, o) {
      if (!n) {
        this.showAreaNumber = this.allArea.length;
      } else {
        this.showAreaNumber = this.allArea.filter((area) => {
          return area.areaName.indexOf(n) !== -1;
        }).length;
      }
    },
    tag(n, o) {
      this.checkedLoops = [];
      this.$refs.tree.setCheckedNodes([]);
    },
    routeName() {
      this.reFresh = false;
      this.$nextTick(() => {
        this.reFresh = true;
      });
      this.selectedNodes = [];
      this.filterText = "";
    },
    master(n, o) {
      this.updateMqtt(n, o);
    },
    currentLoop(n, o) {
      this.updateMqtt(n, o);
    },
    details(n) {
      GET_AREA_LOOPS(this.allArea[n].areaId).then((res) => {
        this.loops = res.data.data.loops.filter(
          (item) => !~item.loopName.indexOf("变压器设备")
        ); // 临时过滤虚拟回路的方案
      });
      this.filterText = "";
    },
    filterText(val) {
      this.$refs.tree.filter(val);
      this.checkedLoops = this.selectedNodes.filter((l) => {
        return l.loopName.indexOf(val) !== -1;
      });
    },
  },
};
</script>

<style scoped lang="less">
  .comparison-head {
      font-weight: bold;
      color: #333333;
      padding: 0 24px;
      justify-content: flex-start;
      background: #ffffff;
      margin:1px 3px;
      height: 56px;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;

      .name {
          margin-right: 57px;
          height: 100%;
          font-size: 24rem;
          line-height: 56px;
          cursor: pointer;
    display: inline-block;
    color: #333;
    text-decoration: none;
          &.active {
              border-bottom: 2px solid rgba(13, 148, 255, 1);
              color: rgba(13, 148, 255, 1);
          }
      }
  }

.clearsel{
  height:45rem;
  line-height: 45rem;
  border-top: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
  text-align: center;
  font-size: 18rem;
  cursor: pointer;
}
.area-list {
  position: absolute;
  left: 0;
  top: 0;
  .w(504);
  .h(520);
  background-color: #fff;
  box-shadow: 0 4rem 40px 0 rgba(0, 43, 102, 0.28);
  padding: 24rem 16rem;
  z-index: 999;

  .areas {
    margin-top: 24rem;
    // min-height: 200rem;
    .h(400);
    .row {
      margin-bottom: 24rem;

      p {
        font-size: 16rem;
        color: #333333;
        font-weight: 400;
        .w(400);
      }

      img {
        .w(48);
        .h(48);
        margin-right: 13rem;
        margin-left: 8rem;
      }
    }
  }

  .search {
    .h(48);
    width: 100%;
    overflow: hidden;
    border-radius: 24rem;
    border: 1px solid rgba(0, 0, 0, 0.15);
    position: relative;

    input {
      width: 100%;
      height: 100%;
      padding: 0 20rem;
      font-size: 16rem;
      color: #000000;
      font-weight: 400;
      line-height: 48rem;
    }

    img {
      position: absolute;
      right: 16rem;
      top: 15rem;
      z-index: 99;
    }
  }
}

#power-data {
  justify-content: space-between;

  // .h(968);
  height: 100%;

  > .data {
    position: relative;
    .w(1265);
    height: 100%;
  }

  .left {
    height: 100%;
    justify-content: flex-start !important;
    background-color: #fff;
    .w(325);

    .list {
      padding: 24rem 0rem 24rem 24rem;
      overflow: hidden;
      width: 100%;

      .search {
        display: flex;
        flex-flow: row nowrap;
        justify-content: center;
        align-items: center;
      }

      input {
        border: none;
        outline: none;
        font-size: 18rem;
        color: #666666;
        .w(262);
      }

      .tree {
        margin-top: 35rem;

        height: 750 / 1080 * 100vh;
        overflow: auto;

        &::-webkit-scrollbar {
          width: 0 !important;
        }

        /deep/ .el-scrollbar__wrap {
          overflow-x: hidden;
          height: calc(100% - 10px);
        }

        .el-tree {
          padding-right: 24rem;
        }
      }
    }
  }
}

.power-data-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  width: 100%;

  .power-data-item1 {
    position: absolute;
    right: 0;
  }

  .power-data-item-label {
    font-size: 18rem;
    font-weight: 400;
    color: #666666;
    width: 80%;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    // white-space: nowrap;
  }

  .power-data-item-label.checked {
    font-weight: bold;
    color: #0d94ff;
  }

  .power-data-item-open {
    color: #68d86a;
    position: absolute;
    right: 0;
  }

  .power-data-item-close {
    position: absolute;
    right: 0;
    color: #fd4238;
  }
}

.no-found-data-warpper {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}

//弹出框样式
.area_popper {
  background-color: #3d4451 !important;
  border-radius: 6px !important;
  opacity: 0.9 !important;
  font-size: 12px !important;
  color: #ffffff !important;
  padding: 0 !important;
  transform: translateY(12px);
}

.showText {
  margin: 8px;
}

&::-webkit-scrollbar {
  width: 0 !important;
}

/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
  height: calc(100% - 10px);
}

.el-tree {
  padding-right: 33rem;
}
</style>
